import { render, staticRenderFns } from "./FinancialReportItem.vue?vue&type=template&id=15b51ccc&scoped=true&"
import script from "./FinancialReportItem.vue?vue&type=script&lang=js&"
export * from "./FinancialReportItem.vue?vue&type=script&lang=js&"
import style0 from "./FinancialReportItem.vue?vue&type=style&index=0&id=15b51ccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b51ccc",
  null
  
)

export default component.exports